// extracted by mini-css-extract-plugin
module.exports = {"paymentInfoPage":"PaymentInfoPage_paymentInfoPage__1pSgx","paymentInfoBlock":"PaymentInfoPage_paymentInfoBlock__31wg0"};